import { minMsg, requireMsg } from "@/lib/prettyZodMessage";
import { z } from "zod";

export const loginSchema = z.object({
  email: z.string().min(1, requireMsg("email")).email(),
  password: z
    .string()
    .min(1, requireMsg("password"))
    .min(8, minMsg("password", 8)),
});

export type Login = z.infer<typeof loginSchema>;

export const loginResSchema = z.object({
  user: z.object({
    id: z.number(),
    name: z.string().nullish(),
    role: z.number(),
    email: z.string(),
  }),
  token: z.string(),
});

export type LoginRes = z.infer<typeof loginResSchema>;
